import { LoadingIcon as LoadingDs, Skeleton, Typography } from "@packages/ds";
import styled from "styled-components";

import { Avatar as AvatarDs } from "ds/Avatar";
import { IconControl } from "ds/Button";
import Tag from "ds/Tag";
import { semiBoldAlias } from "Libs/theme";

export const Wrapper = styled.div``;

export const ProjectTitle = styled(Typography.Title)`
  word-break: break-all;
`;
export const Details = styled.div`
  min-height: 192px;
  padding: 32px 32px 0 32px;
  box-sizing: border-box;
  color: var(--header-ebony-color, var(--ebony));
`;

export const IdRegion = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2px;
  font-size: 13px;
  line-height: 16px;
  ${semiBoldAlias()};
  color: var(
    --id-region-section-color,
    var(--section-granite-color, var(--granite))
  );
`;

export const Wizard = styled.div`
  display: flex;
  margin: 16px 0 0 0;
`;

export const Plan = styled.div`
  margin: 18px 0 0 0;
  ${semiBoldAlias()};
  font-size: 14px;
  line-height: 16px;
  color: var(--header-ebony-color, var(--ebony));

  a {
    margin-left: 8px;
    font-size: 13px;
    text-decoration: none;
    ${semiBoldAlias()};
  }
`;

export const Info = styled.div`
  display: block;
  margin-top: 16px;
`;

export const Label = styled.span`
  display: block;
  color: ${props => (props.theme.name === "contrast" ? "#4A495E" : "#98a0ab")};
  font-size: 14px;
  line-height: 16px;
  ${semiBoldAlias()};
  &:first-letter {
    text-transform: uppercase;
  }
`;

export const Value = styled.span`
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  align-items: center;
  margin-bottom: 4px;
  font-size: 15px;
  line-height: 18px;
  position: relative;
  ${semiBoldAlias()};
  color: var(--header-ebony-color, var(--ebony));

  a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Infos = styled.div`
  display: grid;
  box-sizing: border-box;
  color: var(--header-ebony-color, var(--ebony));
  grid-template-columns: repeat(2, 1fr);
`;

export const Users = styled.div`
  display: flex;
  margin-top: 24px;

  span {
    font-size: 12px;
    line-height: 24px;
    ${semiBoldAlias()};
    color: var(--header-ebony-color, var(--ebony));
  }
`;

export const UsersFullList = styled.div`
  display: none;
  position: absolute;
  z-index: 2;
  top: 24px;
  left: 0;
  width: 224px;
  height: 201px;
  margin: 0;
  padding: 9px 0 9px 16px;
  box-sizing: border-box;
  background-color: var(--section-snow-background-color, var(--snow));
  box-shadow: var(--mode-bs-large);
  border-radius: 2px;
  list-style-type: none;
`;

export const User = styled.div`
  display: block;
  margin: 0;
  padding: 0;
  font-size: 14px;
  line-height: 24px;
  & + & {
    margin-top: 8px;
  }
`;

export const UsersMore = styled.div`
  position: relative;
  &:hover {
    ${UsersFullList} {
      display: block;
    }

    > span {
      color: var(--section-snow-color, var(--snow));
      background-color: var(--section-slate-background-color, var(--slate));
    }
  }
  > span {
    display: block;
    width: 24px;
    height: 24px;
    margin: 0;
    border-radius: 2px;
    background-color: var(
      --section-periwinkle-grey-background-color,
      var(--periwinkle-grey)
    );
    font-weight: bold;
    font-size: 10px;
    line-height: 24px;
    color: var(--section-ebony-color, var(--ebony));
    text-align: center;
    cursor: pointer;
  }
`;

export const Avatar = styled(AvatarDs)`
  margin-right: 2px;
  display: none;

  @media (min-width: 768px) {
    display: inline-block;
  }
`;

export const DedicatedTag = styled(Tag)`
  margin: 7px 0;
`;

export const Layout = styled(Skeleton)`
  :not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const Row = styled(Skeleton.Card)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  padding-right: 32px;
`;

export const ConfigureResourcesButtonWrapper = styled.div`
  position: absolute;
  right: 15px;
  top: -2px;
`;

export const IconControlRegion = styled(IconControl)`
  margin-right: 8px;
  ${({ isGreen }) => isGreen && "color: var(--color-java-600)"};
`;

export const ContentWrapper = styled.div`
  width: 268px;
`;

export const Loading = styled(LoadingDs)`
  margin: 25px auto;
  display: flex;
`;
